module.exports = __webpack_public_path__ + "static/media/Stannis Baratheon 1.a24e1611.jpg";